<template>
  <div class="home">
    <div class="row">
      <v-card elevation="9" class="card">
        <h4>Products</h4>
        <h5>count: {{ this.dashboard.products }}</h5>
        <GChart type="LineChart" :data="chartData" :options="chartOptions" />
      </v-card>
      <v-card elevation="9" class="card">
        <h4>Leads</h4>
        <h5>count: {{ this.dashboard.leads }}</h5>
        <GChart type="LineChart" :data="chartData" :options="chartOptions" />
      </v-card>
      <v-card elevation="9" class="card">
        <h4>Purchase</h4>
        <h5>count: {{ this.dashboard.purchaseorders }}</h5>
        <GChart type="LineChart" :data="chartData" :options="chartOptions" />
      </v-card>
      <v-card elevation="9" class="card">
        <h4>Task</h4>
        <h5>count: {{ this.dashboard.tasks }}</h5>
        <GChart type="LineChart" :data="chartData" :options="chartOptions" />
      </v-card>
      <v-card elevation="9" class="card">
        <h4>Invoices</h4>
        <h5>count: {{ this.dashboard.invoices }}</h5>
        <GChart type="LineChart" :data="chartData" :options="chartOptions" />
      </v-card>
      <v-card elevation="9" class="card">
        <h4>Conversations</h4>
        <h5>count: {{ this.dashboard.conversations }}</h5>
        <GChart type="LineChart" :data="chartData" :options="chartOptions" />
      </v-card>
    </div>

    <v-overlay :value="overlay" opacity="0.98" z-index="9">
      <v-card
        v-scroll.self="onScroll"
        style="background-color:rgba(48, 64, 87, 0.8)"
        class="overflow-y-auto popup-container theme-bg-card-3"
      >
        <h1 v-if="type == 'email'">This is where I will put my content</h1>
        <Calendar v-if="type == 'calendar'" />
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import Calendar from './../components/Calendar.vue';
import { GChart } from 'vue-google-charts';

export default {
  name: 'Home',
  data: () => ({
    dashboard: {},
    overlay: false,
    type: '',
    chartData: [
      ['Year', 'Expected', 'Actual'],
      ['2014', 1000, 500],
      ['2015', 1170, 1200],
      ['2016', 660, 400],
      ['2017', 1030, 1400],
    ],
    chartOptions: {
      chart: {
        title: 'Company Performance',
        subtitle: 'Sales, Expenses, and Profit: 2014-2017',
      },
    },
  }),
  components: {
    Calendar,
    GChart,
  },
  computed: {},
  methods: {
    getDashboard: async function() {
      const rawResponse = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}analytics/all`
      );
      const content = await rawResponse.json();
      this.dashboard = content.response;
      console.log(content);
    },
  },
  mounted() {
    this.getDashboard();
    Event.$on('showCard', (data) => {
      if (this.$route.path !== '/') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('calendar') != -1) {
        this.type = 'calendar';
      }
      this.overlay = true;
    });

    Event.$on('showEmail', (data) => {
      if (this.$route.path !== '/') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('calendar') != -1) {
        this.type = 'email';
      }
      this.overlay = true;
    });

    Event.$on('closeCard', (data) => {
      if (this.$route.path !== '/') {
        return;
      }
      console.log(data);
      this.overlay = false;
    });
  },
};
</script>

<style scoped>
.home {
  padding: 20px;
}
.card {
  margin-left: 1rem;
  padding: 20px;
  border-radius: 5px;
  width: 220px;
  border-radius: 8px !important;
}
.row {
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
}
</style>
